import PropTypes from "prop-types";
import {greyishBlue50, greyishBlue100} from "assets/jss/main";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const sizeData = [
    { eu: 36, us: 4,  it: 36, uk: 3.5 },
    { eu: 37, us: 5,  it: 37, uk: 4   },
    { eu: 38, us: 6,  it: 38, uk: 5   },
    { eu: 39, us: 7,  it: 39, uk: 6   },
    { eu: 40, us: 8,  it: 40, uk: 6.5 },
    { eu: 41, us: 9,  it: 41, uk: 7.5 },
    { eu: 42, us: 10, it: 42, uk: 8   },
];

const columns = ["EU", "US", "IT", "UK"];

SizeConversionRow.propTypes = {
    row: PropTypes.object.isRequired,
    isLast: PropTypes.bool,
};

function SizeConversionRow({ row, isLast = false }) {
    const values = [row.eu, row.us, row.it, row.uk];

    return (
        <TableRow>
            {values.map((val, i) => (
                <TableCell
                    key={i}
                    sx={{
                        borderBottom: isLast ? "none" : `1px solid ${greyishBlue50}`,
                        fontSize: "14px",
                        color: i === 0 ? "#111827" : "#9ca3af",
                        fontWeight: i === 0 ? "600" : "400",
                        width: "25%",
                        padding: "6px 12px",
                    }}
                >
                    {val}
                </TableCell>
            ))}
        </TableRow>
    );
}

SizeConversionTable.propTypes = {
    rows: PropTypes.arrayOf(PropTypes.object),
};

function SizeConversionTable({rows = sizeData }) {
    return (
        <TableContainer
            component={Paper}
            elevation={0}
            sx={{ border: `1px solid ${greyishBlue100}`, borderRadius: "12px", overflow: "hidden" }}
        >
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: "#f9fafb" }}>
                        {columns.map((col) => (
                            <TableCell
                                key={col}
                                sx={{
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#6b7280",
                                    textTransform: "uppercase",
                                    borderBottom: `1px solid ${greyishBlue100}`,
                                    width: "25%",
                                    padding: "8px 12px",
                                }}
                            >
                                {col}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row, index) => (
                        <SizeConversionRow
                            key={row.eu}
                            row={row}
                            isLast={index === rows.length - 1}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default SizeConversionTable;
